import { useStore } from "@nanostores/react"
import { useMemo } from "react"

import { useEvent } from "shared/lib/useEvent"

import { persistentAtom } from "@nanostores/persistent"

const lastReadAtom = persistentAtom<string | undefined>("last-read-portal-news")

export function useLastReadPortalNews() {
  const lastReadString = useStore(lastReadAtom)

  const lastRead = useMemo(() => {
    return lastReadString ? new Date(lastReadString) : null
  }, [lastReadString])

  const markAllAsRead = useEvent(() => {
    lastReadAtom.set(new Date().toISOString())
  })

  const markAllAsUnread = useEvent(() => {
    lastReadAtom.set(undefined)
  })

  return { markAllAsRead, markAllAsUnread, lastRead }
}
